export const ApiDef_EHROrderConfiguration = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map